import { useEffect } from 'react';

import { Row, Col, Form } from "react-bootstrap";

import "./style.css";

export default function SearchBar(props) {
  
  const { 
    placeholder, 
    query, 
    setQuery
  } = props;
  

  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  // const [] = useState("");
  useEffect(() => {
    // props.setQuery(query)
  }, [query])

  return (
    <Form onSubmit={e => { e.preventDefault(); }} >
      <Form.Group as={Row} className="mb-3" >
        <Col xs={12} sm={12} md={12} xl={12}>
          {/* <Form.Control type="text" placeholder={placeholder} style={{width:"100%"}}/> */}

          <Form.Control
            // autoFocus
            type="search"
            placeholder={placeholder}
            className="me-2"
            aria-label="Search"
            autoComplete="off"
            onChange={event => setQuery(event.target.value)}
            style={{width:"100%"}}
            value={query}
          />

        </Col>
        {/* <Col xs={4} sm={2} md={2} xl={1}>
          <Button variant="primary" style={{width:"100%"}} ><FaSearch size={20}/></Button>
        </Col> */}
      </Form.Group>
      
      <Form.Group>
      <div className="search-bar-letters" >
        {
          letters.map((item, index) => {
            // if (index + 1 !== letters.length) {
              return <span key={index} > <a className="searh-a" onClick={()=>setQuery(item)} >{item}</a> | </span>
            // } else {
              // return <a key={index} className="searh-a" onClick={()=>setQuery(item)}>{item}</a>
            // }
          })
        }
        <a className="searh-a" onClick={()=>setQuery("")}>&#x2731;</a>
      </div>
      </Form.Group>
    </Form>
  )
}
